import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
import { useState, useEffect } from "react";
import ReactModal from "react-modal";
import axios from "axios";

const CreaEquipos = () => {
  const [postNombre, setPostNombre] = useState([]);
  const [postCodigo, setPostCodigo] = useState([]);
  const [postMarca, setPostMarca] = useState([]);

  // Nuevo estado para almacenar los tipos de equipo
  const [tipoEquipos, setTipoEquipos] = useState([]);
  const [tipoEquipoSeleccionado, setTipoEquipoSeleccionado] = useState("");

  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    // Llamada al API para obtener los tipos de equipos
    axios
      .get(
        "https://inspecciongnvback.azurewebsites.net/api/v1/ObtenerTipoEquipos",
      )
      .then((response) => {
        setTipoEquipos(response.data); // Guardar los datos en el estado
      })
      .catch((error) => {
        console.error("Error al obtener los tipos de equipo:", error);
      });
  }, []); // El arreglo vacío asegura que la solicitud se haga solo una vez al montar el componente

  const postData = (e) => {
    e.preventDefault();
    const fechaActual = new Date().toISOString().split("T")[0];

    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://inspecciongnvback.azurewebsites.net/api/v1/CreaEquipos",
      data: {
        nombre: postNombre,
        codigo: postCodigo,
        fechaFabricacion: fechaActual,
        marca: postMarca,
        capacidad: "",
        prueba: "",
        ultimaPrueba: "",
        tipo: tipoEquipoSeleccionado,
      },
    })
      .then((Response) => {
        console.log(Response.data);
        alert("Equipo creado con éxito!");
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear equipo: " + error);
      });
  };

  return (
    <>
      {/* Page content */}
      <button
        variant="contained"
        className="btn btn-primary btn-lg"
        color="primary"
        onClick={handleOpenModalTest}
      >
        Nuevo
      </button>
      <ReactModal isOpen={modalIsOpen} onRequestClose={closeModal}>
        <Container className="mt--7" fluid>
          <Row>
            <Col className="order-xl-1" xl="12">
              <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0">
                  <Row className="align-items-center">
                    <Col xs="8">
                      <h3 className="mb-0">My account</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                      <Button
                        color="primary"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        size="sm"
                      >
                        Settings
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Form>
                    <h6 className="heading-small text-muted mb-4">
                      Crear Equipos
                    </h6>
                    <div className="pl-lg-4">
                      {/* Nuevo campo tipoEquipo */}
                      <Row>
                        <Col lg="12">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-tipoEquipo"
                            >
                              Tipo de Equipo
                            </label>
                            <Input
                              type="select"
                              className="form-control-alternative"
                              id="input-tipoEquipo"
                              onChange={(e) =>
                                setTipoEquipoSeleccionado(e.target.value)
                              }
                            >
                              <option value="">
                                Seleccionar Tipo de Equipo
                              </option>
                              {tipoEquipos.map((equipo) => (
                                <option key={equipo.id} value={equipo.id}>
                                  {equipo.nombre}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                      </Row>
                      {/* Otros campos */}
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-username"
                            >
                              Nombre
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-username"
                              placeholder=""
                              type="text"
                              onChange={(e) => setPostNombre(e.target.value)}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                              Código
                            </label>
                            <Input
                              className="form-control-alternative"
                              id=""
                              type="text"
                              onChange={(e) => setPostCodigo(e.target.value)}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-last-name"
                            >
                              Marca
                            </label>
                            <Input
                              className="form-control-alternative"
                              defaultValue=""
                              id="input-last-name"
                              placeholder=""
                              onChange={(e) => setPostMarca(e.target.value)}
                              type="text"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                    <hr className="my-4" />
                  </Form>
                </CardBody>
                <button
                  className="btn btn-primary btn-lg"
                  color="primary"
                  onClick={postData}
                >
                  Guardar
                </button>
              </Card>
            </Col>
          </Row>
        </Container>
      </ReactModal>
    </>
  );
};

export default CreaEquipos;
